import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { completeProfilePath, registerUrl } from '../utils/paths';
import { useAuth } from '../contexts/AuthContext';

/**
 * Legacy club invite URLs (/register-player/:token) redirect to unified signup
 * or profile completion with the club pre-selected.
 */
const PlayerRegistrationLink = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const redirect = async () => {
      try {
        const club = await api.getClubByToken(token);
        if (isAuthenticated) {
          navigate(completeProfilePath(club.id), { replace: true });
        } else {
          window.location.replace(registerUrl(club.id));
        }
      } catch (err) {
        setError(err.message || 'Invalid or expired invite link');
      }
    };

    redirect();
  }, [token, navigate, isAuthenticated]);

  if (error) {
    return (
      <div className="card">
        <div className="alert alert-error">{error}</div>
      </div>
    );
  }

  return <div className="loading">Redirecting to signup…</div>;
};

export default PlayerRegistrationLink;
